import company_class from "../class/company";

const [w, d, Company] = [window, document, new company_class()];

const domReady = TPL => false;

const jqInit = () => Company.init().getNav();

export default function PROFILE () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
}